



























































































import Vue from 'vue';
import SquareEditOutlineIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import CheckboxBlankOutlineIcon from 'vue-material-design-icons/CheckboxBlankOutline.vue';
import CheckboxMarkedOutlineIcon from 'vue-material-design-icons/CheckboxMarkedOutline.vue';
import StarCircleIcon from 'vue-material-design-icons/StarCircle.vue';
import ThumbUpIcon from 'vue-material-design-icons/ThumbUp.vue';
import ThumbDownIcon from 'vue-material-design-icons/ThumbDown.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import Content from '@/dex-shared/components/content/Content.vue';
import getAssetPath from '@/helpers/assets';

export default Vue.extend({
  components: {
    Content,
    pxCard,
    SquareEditOutlineIcon,
    CheckboxBlankOutlineIcon,
    CheckboxMarkedOutlineIcon,
    StarCircleIcon,
    ThumbUpIcon,
    ThumbDownIcon,
  },

  props: {
    solution: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    isBestVoted: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      monitorImgSrc: getAssetPath('monitores-descomplica.svg'),
      defaultUserImg: getAssetPath('default_user.svg'),
    };
  },

  computed: {
    filteredReports: function() {
      return this.solution.reportsBySolutionId.nodes.filter(
        (report: any) => !report.done,
      );
    },
  },
  methods: {
    toggleReportDone: async function(report: any) {
      let reportId = report.id;
      let newState = !report.done;
      await this.$store.dispatch('TOGGLE_REPORT_DONE', { reportId, newState });
      report.done = !report.done;
    },
  },
});
